import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { config } from "@config";
import { ModalService } from "@core-services/modal.service";
import { Network } from "@modules/+new/payments/features/crypto-deposit/domain/entities/network.model";
import { PaymentsCryptocoin } from "@modules/+new/payments/shared-payments/entities/payments-cryptocoin.model";
import { AddressBookWalletFacade } from "@modules/main/components/address-book-wallet/services/address-book-wallet.facade";

@Component({
	selector: "uk-business-user-selector",
	templateUrl: "./uk-business-user-selector.component.html",
	styleUrl: "./uk-business-user-selector.component.scss",
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class UKBusinessUserSelectorComponent {
	@Input() selectedCryptocoin: PaymentsCryptocoin = null;
	@Input() selectedNetwork: Network = null;

	constructor(
		private readonly walletFacade: AddressBookWalletFacade,
		private readonly modalService: ModalService
	) {}

	public learnMoreUrl: string = config.externalPaths["travel_rule"]["faq"];
	public chooseClientStepActive: boolean = false;
	public onBehalfOf?: string;

	public onBackButtonClick(): void {
		if (this.chooseClientStepActive) {
			this.chooseClientStepActive = false;
		} else {
			this.modalService.pop();
		}
	}

	public onCancelButtonClick(): void {
		this.modalService.popAll();
	}

	public selectBusiness(): void {
		this.walletFacade.onBehalfOf.next("");
	}

	public selectClient(): void {
		this.chooseClientStepActive = true;
	}

	public save(): void {
		this.walletFacade.onBehalfOf.next(this.onBehalfOf);
	}
}
